import { useLocation, Navigate } from "react-router-dom";
// material
import { styled } from '@mui/material/styles';
import { Stack, Container, Card, Typography } from '@mui/material';
// components
import Page from '../../../components/Page';
import FillInstallationReport from "../../../components/SidebarMenuComponents/OAComponent/FillInstallationReport";
import StickyHeader from "../../../components/Common/StickyHeader";

// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
}));
export default function FillInstallationReportPage() {
    const location = useLocation();
    const fillInstallation = location.state;
    return (
        <Page title=" Fill Installation Report| tiketic" >
            
            <StickyHeader title="Fill Installation Report" />

            <ContentStyle>
                <FillInstallationReport fillInstallation={fillInstallation} />
            </ContentStyle>
        </Page>
    );
}

